module.exports = __webpack_public_path__ + "static/media/video_tutorial.acbcee8a.svg";